import { render, staticRenderFns } from "./AdminModal.vue?vue&type=template&id=79113676&"
import script from "./AdminModal.vue?vue&type=script&lang=js&"
export * from "./AdminModal.vue?vue&type=script&lang=js&"
import style0 from "./AdminModal.vue?vue&type=style&index=0&id=79113676&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports